<header class="pc-header ">
    <div class="header-wrapper">
        <div class="row d-flex w-100">
            <div class="col-4">
                <div class="me-auto pc-mob-drp">
                    <ul class="list-unstyled">
                        <li class="pc-h-item pc-sidebar-collapse">
                            <a href="javascript:void(0)" class="pc-head-link ms-0" id="sidebar-hide">
                                <i class="ti ti-menu-2"></i>
                            </a>
                        </li>
                        <li class="pc-h-item pc-sidebar-popup">
                            <a href="javascript:void(0)" class="pc-head-link ms-0" id="mobile-collapse">
                                <i class="ti ti-menu-2"></i>
                            </a>
                        </li>
                        <li class="pc-h-item">
                            <img src="assets/images/lynkit_logo.png" id="logo-web">
                        </li>

                        <!-- <li class="dropdown pc-h-item">
                            <a class="pc-head-link dropdown-toggle arrow-none m-0 trig-drp-search" data-bs-toggle="dropdown"
                                href="javascript:void(0)" role="button" aria-haspopup="false" aria-expanded="false">
                                <svg class="pc-icon">
                                    <use xlink:href="#custom-search-normal-1"></use>
                                </svg>
                            </a>
                            <div class="dropdown-menu pc-h-dropdown drp-search">
                                <form class="px-3 py-2">
                                    <input type="search" class="form-control border-0 shadow-none"
                                        placeholder="Search here. . ." />
                                </form>
                            </div>
                        </li> -->
                    </ul>
                </div>
            </div>
            <div class="col-4">
                <ul class="list-unstyled w-100">
                    <li class="dropdown pc-h-item d-none d-md-inline-flex w-100">
                        <input id="search" (input)="onSearch($event)" [(ngModel)]="searchQuery" type="search"
                            class="form-control w-100" placeholder="Search Terminology">
                    </li>
                    <ul *ngIf="filteredPages.length" class="search-dropdown">
                        <li *ngFor="let page of filteredPages" (click)="navigateToPage(page)">{{ page }}</li>
                    </ul>
                </ul>
            </div>
            <div class="col-4 d-flex justify-content-end" >
                <ul class="list-unstyled">
                    <li class="dropdown pc-h-item">
                        <a class="pc-head-link dropdown-toggle arrow-none me-0" data-bs-toggle="dropdown"
                            href="javascript:void(0)" role="button" aria-haspopup="false" aria-expanded="false">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-sun-1"></use>
                            </svg>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end pc-h-dropdown">
                            <a href="javascript:void(0)" class="dropdown-item" (click)="layoutChange('dark')">
                                <svg class="pc-icon">
                                    <use xlink:href="#custom-moon"></use>
                                </svg>
                                <span>Dark</span>
                            </a>
                            <a href="javascript:void(0)" class="dropdown-item" (click)="layoutChange('light')">
                                <svg class="pc-icon">
                                    <use xlink:href="#custom-sun-1"></use>
                                </svg>
                                <span>Light</span>
                            </a>
                            <a href="javascript:void(0)" class="dropdown-item" (click)="layoutChange('default')">
                                <svg class="pc-icon">
                                    <use xlink:href="#custom-setting-2"></use>
                                </svg>
                                <span>Default</span>
                            </a>
                        </div>
                    </li>
                    <li class="pc-h-item">
                        <a (click)="getExchangeRates()" href="javascript:void(0)" class="pc-head-link me-0"
                            data-bs-toggle="offcanvas" data-bs-target="#announcement" aria-controls="announcement">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-dollar-square"></use>
                            </svg>
                        </a>
                    </li>
                    <li class="dropdown pc-h-item header-user-profile">
                        <a class="pc-head-link dropdown-toggle arrow-none me-0" data-bs-toggle="dropdown"
                            href="javascript:void(0)" role="button" aria-haspopup="false" data-bs-auto-close="outside"
                            aria-expanded="false">
                            <img src="assets/img/user.png" alt="user-image" class="user-avtar" />
                        </a>
                        <div class="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown">
                            <div class="dropdown-header d-flex align-items-center justify-content-between">
                                <h5 class="m-0">Profile</h5>
                            </div>
                            <div class="dropdown-body">
                                <div class="profile-notification-scroll position-relative"
                                    style="max-height: calc(100vh - 225px)">
                                    <div class="d-flex mb-1">
                                        <div class="flex-shrink-0">
                                            <img src="assets/img/user.png" alt="user-image" class="user-avtar wid-35" />
                                        </div>
                                        <div class="flex-grow-1 ms-3" style="word-break: break-word;">
                                            <h6 class="mb-1">{{token?.name}}</h6>
                                            <span>{{token?.email}}</span>
                                        </div>
                                    </div>
                                    <hr class="border-secondary border-opacity-50" />

                                    <p class="text-span">Manage</p>
                                    <a href="javascript:void(0)" routerLink="/setting" class="dropdown-item">
                                        <span>
                                            <svg class="pc-icon text-muted me-2">
                                                <use xlink:href="#custom-setting-outline"></use>
                                            </svg>
                                            <span>Settings</span>
                                        </span>
                                    </a>

                                    <!-- <a href="javascript:void(0)" class="dropdown-item">
                                            <span>
                                                <svg class="pc-icon text-muted me-2">
                                                    <use xlink:href="#custom-lock-outline"></use>
                                                </svg>
                                                <span>Change Password</span>
                                            </span>
                                        </a> -->

                                    <a href="javascript:void(0)" (click)="logout()" class="dropdown-item ">
                                        <span>
                                            <i class="ti ti-power"></i>
                                            <span>Logout</span>
                                        </span>
                                    </a>

                                </div>
                            </div>
                        </div>
                    </li>
                </ul>

            </div>
        </div>
    </div>
</header>


<div class="offcanvas pc-announcement-offcanvas offcanvas-end" tabindex="-1" id="announcement"
    aria-labelledby="announcementLabel">
    <div class="offcanvas-header border">
        <h5 class="offcanvas-title" id="announcementLabel">Exchange Rates <span
                class="text-uppercase">({{exchangeRates?.base}})</span> </h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body pt-3">
        <div class="scroll-block">
            <div class="mb-2">
                <input type="text" class="form-control" placeholder="Search Currency Code" [(ngModel)]="searchCurrency"
                    (keyup)="filterExchangeRates()" />
            </div>
            @for (item of Object.entries(filteredExchangeRates); track $index)
            {
            <div class="card mb-3 p-3 border-primary" *ngIf=" item[0] != 'base' && item[0] != 'day'">
                <div class="card-body p-0" *ngIf="item[0] | cc as currency">
                    <div class="d-flex align-items-center">
                        <div class="flex-shrink-0">
                            <div class="avtar avtar-xs bg-light-primary">
                                {{currency.symbol || currency.code.charAt(0)}}
                                <!-- <i class="ti ti-cash-banknote f-16"></i> -->
                            </div>
                        </div>
                        <div class="flex-grow-1 ms-2">
                            <div class="f-14">
                                <ng-container *ngIf="(item[0] === 'alb' ? 'ALL' : item[0])">
                                    {{ currency.code }}
                                    <br>
                                    <small>{{ currency.currency }}</small>
                                </ng-container>
                            </div>
                        </div>
                        <div>
                            <!-- {{ item[1]  }} -->
                            <ng-container *ngIf="(item[0] === 'alb' ? 'ALL' : item[0])">
                                <div class="badge bg-light-primary f-12">
                                    {{ item[1] }}
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</div>

<!-- <div #contentContainer>
    <ng-container [ngSwitch]="activeComponent">
      <app-market-benchmarks *ngSwitchCase="'market benchmarks'"></app-market-benchmarks>
      <app-terminal-handling-charges *ngSwitchCase="'terminal handling charges'"></app-terminal-handling-charges>
      <app-geo-hierarchy-methodology *ngSwitchCase="'geo-hierarchy methodology'"></app-geo-hierarchy-methodology>
      <app-ocean-rate-methodology *ngSwitchCase="'ocean rate methodology'"></app-ocean-rate-methodology>
      <app-contract-length *ngSwitchCase="'contract length'"></app-contract-length>
      <app-market-metrics *ngSwitchCase="'market metrics'"></app-market-metrics>
      <app-contracted-within *ngSwitchCase="'contracted within'"></app-contracted-within>
      <app-container-types *ngSwitchCase="'container types'"></app-container-types>
      <app-future-rates *ngSwitchCase="'future rates'"></app-future-rates>
      <app-coverage *ngSwitchCase="'coverage'"></app-coverage>
      <app-contract-validity *ngSwitchCase="'contract validity'"></app-contract-validity>
      <app-market-benchmarks *ngSwitchDefault></app-market-benchmarks>
    </ng-container>
</div> -->